import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, HelpCircle, Gift, Heart } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="mx-auto max-w-lg text-center">
        {/* Large 404 Display */}
        <div className="mb-6">
          <h1 className="text-8xl font-bold text-primary/20 sm:text-9xl">404</h1>
        </div>

        {/* Message */}
        <h2 className="mb-3 text-2xl font-semibold text-foreground">
          Page not found
        </h2>
        <p className="mb-8 text-muted-foreground">
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back on track.
        </p>

        {/* Primary Actions */}
        <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button asChild size="lg">
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" onClick={() => window.history.back()}>
            <span className="cursor-pointer" onClick={() => window.history.back()}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Go Back
            </span>
          </Button>
        </div>

        {/* Helpful Links */}
        <div className="rounded-lg border border-border bg-card p-6">
          <h3 className="mb-4 text-sm font-medium text-foreground">
            Popular pages you might be looking for:
          </h3>
          <div className="grid gap-2 sm:grid-cols-2">
            <Link 
              to="/pricing" 
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
            >
              <Heart className="h-4 w-4" />
              Pricing & Plans
            </Link>
            <Link 
              to="/gift" 
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
            >
              <Gift className="h-4 w-4" />
              Gift a Tribute
            </Link>
            <Link 
              to="/resources" 
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
            >
              <HelpCircle className="h-4 w-4" />
              Resources & Help
            </Link>
            <Link 
              to="/support" 
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
            >
              <HelpCircle className="h-4 w-4" />
              Support Center
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
